// extracted by mini-css-extract-plugin
export default {"tupacGrid":"qm-z","tupacHeader":"rm-z","tupacHeader2":"sm-z","tupacMenu":"tm-z","tupacMenu2":"um-z","tupacMain":"vm-z","tupacMain2":"wm-z"};